import React from 'react'
import { useTranslation } from 'react-i18next'

export const HeaderAreasImanage = shouldShow => {
  const { t } = useTranslation()

  return shouldShow ? (
    <>
      <hr />
      <h5 className="_mb-0 _text-3 _text-gray-700">{t('collaborators_area.areas_i_manage')}</h5>
    </>
  ) : null
}
